// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6440285e","455":"c5e98e5b","977":"bc15f015"}[chunkId] + ".chunk.js";
};